/* =========================================================
	ACCORDION CARDS JS
	Progressive enhancement for accordion functionality
	Adds exclusive behavior and smooth animations

	- Only one accordion item can be open at a time within each [data-accordion-cards] container
	- Uses max-height and opacity transitions for smooth open/close
	- Measures actual content height for precise animations
	- Gracefully degrades - if JS is disabled, accordions work normally
	- Preserves original styles and behavior
	- No dependencies
========================================================= */
(function () {
   'use strict';

   // Configuration
   const ANIMATION_DURATION = 300;
   const ANIMATION_EASING = 'ease-out';

   /**
    * Initialize accordion enhancements
    */
   function initAccordions() {
      const accordionContainers = document.querySelectorAll(
         '[data-accordion-cards]'
      );

      accordionContainers.forEach((container) => {
         const details = container.querySelectorAll('details');

         if (details.length === 0) return;

         // Add exclusive behavior and animations to each details element
         details.forEach((detail) => {
            enhanceDetailsElement(detail, details);
         });
      });
   }

   /**
    * Enhance a single details element
    */
   function enhanceDetailsElement(detail, allDetails) {
      const summary = detail.querySelector('summary');
      const content = detail.querySelector('.prose');

      if (!summary || !content) return;

      // Store original content styles
      const originalOverflow = content.style.overflow;
      const originalMaxHeight = content.style.maxHeight;

      // Handle click for exclusive behavior and smooth animations
      summary.addEventListener('click', function (e) {
         e.preventDefault();

         if (detail.hasAttribute('open')) {
            // Closing current item
            closeWithAnimation(detail, content);
         } else {
            // Opening current item - close others first
            closeOtherDetails(detail, allDetails);
            openWithAnimation(detail, content);
         }
      });

      // Restore original styles if needed
      detail.addEventListener('toggle', function () {
         if (!detail.hasAttribute('open')) {
            content.style.overflow = originalOverflow;
            content.style.maxHeight = originalMaxHeight;
         }
      });
   }

   /**
    * Close other open details elements (exclusive behavior)
    */
   function closeOtherDetails(currentDetail, allDetails) {
      allDetails.forEach((detail) => {
         if (detail !== currentDetail && detail.hasAttribute('open')) {
            const content = detail.querySelector('.prose');
            if (content) {
               closeWithAnimation(detail, content);
            }
         }
      });
   }

   /**
    * Open details with smooth animation
    */
   function openWithAnimation(detail, content) {
      // Set initial state for animation
      content.style.overflow = 'hidden';
      content.style.maxHeight = '0px';
      content.style.opacity = '0';

      // Open the details
      detail.setAttribute('open', '');

      // Get the natural height
      const naturalHeight = content.scrollHeight;

      // Animate to natural height
      requestAnimationFrame(() => {
         content.style.transition = `max-height ${ANIMATION_DURATION}ms ${ANIMATION_EASING}, opacity ${ANIMATION_DURATION}ms ${ANIMATION_EASING}`;
         content.style.maxHeight = naturalHeight + 'px';
         content.style.opacity = '1';

         // Clean up after animation
         setTimeout(() => {
            content.style.maxHeight = '';
            content.style.overflow = '';
            content.style.transition = '';
         }, ANIMATION_DURATION);
      });
   }

   /**
    * Close details with smooth animation
    */
   function closeWithAnimation(detail, content) {
      const currentHeight = content.scrollHeight;

      // Set current height and prepare for animation
      content.style.overflow = 'hidden';
      content.style.maxHeight = currentHeight + 'px';
      content.style.transition = `max-height ${ANIMATION_DURATION}ms ${ANIMATION_EASING}, opacity ${ANIMATION_DURATION}ms ${ANIMATION_EASING}`;

      // Force reflow
      content.offsetHeight;

      // Animate to closed state
      content.style.maxHeight = '0px';
      content.style.opacity = '0';

      // Actually close the details after animation
      setTimeout(() => {
         detail.removeAttribute('open');
         content.style.overflow = '';
         content.style.maxHeight = '';
         content.style.opacity = '';
         content.style.transition = '';
      }, ANIMATION_DURATION);
   }

   /**
    * Initialize when DOM is ready
    */
   function ready(fn) {
      if (document.readyState !== 'loading') {
         fn();
      } else {
         document.addEventListener('DOMContentLoaded', fn);
      }
   }

   // Initialize the enhancements
   ready(initAccordions);
})();
